import {
  AlertDialog,
  AlertDialogAction,
  AlertDialogCancel,
  AlertDialogContent,
  AlertDialogDescription,
  AlertDialogFooter,
  AlertDialogHeader,
  AlertDialogTitle,
} from '@/components/ui/alert-dialog'

interface CheckOutTransientStayDialogProps {
  open: boolean
  onOpenChange: (open: boolean) => void
  bookingNumber: string
  onConfirm: () => void
  isPending: boolean
}

export function CheckOutTransientStayDialog({
  open,
  onOpenChange,
  bookingNumber,
  onConfirm,
  isPending,
}: CheckOutTransientStayDialogProps) {
  return (
    <AlertDialog open={open} onOpenChange={onOpenChange}>
      <AlertDialogContent>
        <AlertDialogHeader>
          <AlertDialogTitle>Check Out</AlertDialogTitle>
          <AlertDialogDescription>
            Check out booking{' '}
            <span className="font-mono font-semibold">{bookingNumber}</span>?
            This will set the actual checkout time to now.
          </AlertDialogDescription>
        </AlertDialogHeader>

        <AlertDialogFooter>
          <AlertDialogCancel disabled={isPending}>Cancel</AlertDialogCancel>
          <AlertDialogAction
            onClick={onConfirm}
            disabled={isPending}
          >
            {isPending ? 'Processing…' : 'Confirm Check Out'}
          </AlertDialogAction>
        </AlertDialogFooter>
      </AlertDialogContent>
    </AlertDialog>
  )
}
